import * as React from "react";
import { ChangeEvent, InputHTMLAttributes, useContext } from "react";
import styled from "styled-components";

import { RadioGroupContext } from "./RadioGroup";
import { themeValues } from "../../theme";
import { FormControlContext } from "../../FormControl/FormControl";

export const StyledRadio = styled.input`
  cursor: pointer;
  font-size: ${themeValues.fontSize.normal};
  margin-right: 5px;
`;
StyledRadio.displayName = "StyledRadio";

interface IRadioProps extends InputHTMLAttributes<HTMLInputElement> {
  value: string;

  name?: string;

  disabled?: boolean;

  checked?: boolean;

  required?: boolean;
}

export function Radio({ id: idProp, value, name: nameProp, disabled: disabledProp, checked, required, onChange }: IRadioProps): JSX.Element {
  const radioGroup = useContext(RadioGroupContext);
  const formControl = useContext(FormControlContext)

  const id = idProp || formControl?.id;

  function handleOnChange(e: ChangeEvent<HTMLInputElement>) {
    radioGroup?.onChange && radioGroup.onChange(e);
    onChange && onChange(e);
  }

  const name = nameProp || radioGroup?.name;
  const disabled = disabledProp || formControl?.disabled;

  return <StyledRadio
    id={id}
    type="radio"
    value={value}
    name={name}
    disabled={disabled}
    checked={checked || radioGroup?.value === value}
    required={required}
    onChange={handleOnChange}
  />;
}